import { render, staticRenderFns } from "./detailPage.vue?vue&type=template&id=66adefc6&scoped=true&"
import script from "./detailPage.vue?vue&type=script&lang=ts&"
export * from "./detailPage.vue?vue&type=script&lang=ts&"
import style0 from "./detailPage.vue?vue&type=style&index=0&id=66adefc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66adefc6",
  null
  
)

export default component.exports